import React from 'react';

function Team() {
  return (
    <div>
      <section
        id="team"
        class="team section-bg"
        style={{ scrollMarginTop: '20px' }}
      >
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <br />
            <h2>Message from Founder</h2>
            <p>
              Welcome, and thank you for visiting our store! My goal is to
              provide
              <strong>
                {' '}
                affordable, reliable, and genuine digital solutions{' '}
              </strong>
              —from <strong>fast web hosting</strong> to
              <strong> authentic software licenses</strong>. I believe that
              everyone deserves access to high-quality digital products without
              unnecessary hassle or inflated prices.
            </p>
            <br />
            <p>
              Customer satisfaction is my top priority, and I strive to ensure a
              <span class="fw-bold"> smooth, secure, and seamless </span>
              experience for every user. I am also continuously working to
              <span class="fw-bold"> add more awesome services </span> while
              keeping them{' '}
              <span class="fw-bold"> affordable and accessible </span> for
              everyone.
            </p>
            <br />
            <p>
              If you have any questions or need assistance, feel free to reach
              out. Let’s build something great together!
            </p>
            <br />
            <p>
              Stay connected with me on social media for updates and exclusive
              offers.
            </p>
          </div>

          <div class="row">
            <div class="col-lg-3" data-aos="zoom-in" data-aos-delay="100"></div>
            <div class="col-lg-6" data-aos="zoom-in" data-aos-delay="100">
              <div class="member d-flex align-items-start">
                <div class="pic">
                  <img
                    src="assets/img/team/team-1.jpg"
                    // height="200px"
                    // width="200px"
                    class="img-fluid"
                    di
                    alt=""
                  />
                </div>
                <div class="member-info mx-3">
                  <br />
                  <span>Meet the Founder</span>
                  <h4>Varun Kumar</h4>
                  <p>Follow Me on Social Media</p>
                  <div class="social">
                    <a target="new" href="https://x.com/varunwaun_">
                      <i class="ri-twitter-fill"></i>
                    </a>
                    <a target="new" href="https://www.facebook.com/varunwaun">
                      <i class="ri-facebook-fill"></i>
                    </a>
                    <a target="new" href="https://www.instagram.com/varunwaun/">
                      <i class="ri-instagram-fill"></i>
                    </a>
                    <a target="new" href="http://linkedin.com/in/varunwaun">
                      <i class="ri-linkedin-box-fill"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* <div
              class="col-lg-6 mt-4 mt-lg-0"
              data-aos="zoom-in"
              data-aos-delay="200"
            >
              <div class="member d-flex align-items-start">
                <div class="pic">
                  <img
                    src="assets/img/team/team-2.jpg"
                    class="img-fluid"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Sarah Jhonson</h4>
                  <span>Product Manager</span>
                  <p>
                    Aut maiores voluptates amet et quis praesentium qui senda
                    para
                  </p>
                  <div class="social">
                    <a href>
                      <i class="ri-twitter-fill"></i>
                    </a>
                    <a href>
                      <i class="ri-facebook-fill"></i>
                    </a>
                    <a href>
                      <i class="ri-instagram-fill"></i>
                    </a>
                    <a href>
                      <i class="ri-linkedin-box-fill"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div> */}

            {/* <div
                class="col-lg-6 mt-4"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <div class="member d-flex align-items-start">
                  <div class="pic">
                    <img
                      src="assets/img/team/team-3.jpg"
                      class="img-fluid"
                      alt=""
                    />
                  </div>
                  <div class="member-info">
                    <h4>William Anderson</h4>
                    <span>CTO</span>
                    <p>
                      Quisquam facilis cum velit laborum corrupti fuga rerum
                      quia
                    </p>
                    <div class="social">
                      <a href>
                        <i class="ri-twitter-fill"></i>
                      </a>
                      <a href>
                        <i class="ri-facebook-fill"></i>
                      </a>
                      <a href>
                        <i class="ri-instagram-fill"></i>
                      </a>
                      <a href>
                        <i class="ri-linkedin-box-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-6 mt-4"
                data-aos="zoom-in"
                data-aos-delay="400"
              >
                <div class="member d-flex align-items-start">
                  <div class="pic">
                    <img
                      src="assets/img/team/team-4.jpg"
                      class="img-fluid"
                      alt=""
                    />
                  </div>
                  <div class="member-info">
                    <h4>Amanda Jepson</h4>
                    <span>Accountant</span>
                    <p>
                      Dolorum tempora officiis odit laborum officiis et et
                      accusamus
                    </p>
                    <div class="social">
                      <a href>
                        <i class="ri-twitter-fill"></i>
                      </a>
                      <a href>
                        <i class="ri-facebook-fill"></i>
                      </a>
                      <a href>
                        <i class="ri-instagram-fill"></i>
                      </a>
                      <a href>
                        <i class="ri-linkedin-box-fill"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div> */}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Team;
